const A = '/assets/casino/solutions/';
const MAP = '/assets/casino/maps/';

// ---------------------------------------------------------------------------
// Casino sub-area configs
// ---------------------------------------------------------------------------
export const casinoAreas = {
  'casino-floor': {
    pageClass: 'casinoFloorPage',
    mapBg: MAP + 'Casino-Floor.png',
    title: 'Casino Floor',
    text: "Ensure your patrons can focus on the game or slot, not on finding a server. Individual QR codes identify each machine or position at a table for self-service ordering, so the servers know exactly where to deliver their orders without any interruptions. Or enable servers to take orders and accept payment wherever the patron is with mobile all-in-one devices.",
    solutions: [
      { name: 'InfoGenesis', path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Fly',      path: 'ig-fly',       icon: A + 'AgilysysIGFly.svg',        screenshot: A + 'fly-tap-pay.png' },
      { name: 'IG OnDemand', path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg',   screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Quick Pay',path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',   screenshot: A + 'app-qr-quickpay.png' },
    ],
  },
  'poker-room': {
    pageClass: 'pokerRoomPage',
    mapBg: MAP + 'Casino-Poker-Room.png',
    title: 'Poker Room',
    text: "Ensure your patrons can focus on the game or slot, not on finding a server. Individual QR codes identify each machine or position at a table for self-service ordering, so the servers know exactly where to deliver their orders without any interruptions. Or enable servers to take orders and accept payment wherever the patron is with mobile all-in-one devices.",
    solutions: [
      { name: 'InfoGenesis', path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Fly',      path: 'ig-fly',       icon: A + 'AgilysysIGFly.svg',       screenshot: A + 'fly-tap-pay.png' },
      { name: 'IG Quick Pay',path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',  screenshot: A + 'app-qr-quickpay.png' },
    ],
  },
  sportsbook: {
    pageClass: 'sportsbookPage',
    mapBg: MAP + 'Casino-Sportsbook.png',
    title: 'Sportsbook',
    text: "Ensure your patrons can focus on the game or slot, not on finding a server. Individual QR codes identify each machine or position at a table for self-service ordering, so the servers know exactly where to deliver their orders without any interruptions. Or enable servers to take orders and accept payment wherever the patron is with mobile all-in-one devices.",
    solutions: [
      { name: 'InfoGenesis', path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Fly',      path: 'ig-fly',       icon: A + 'AgilysysIGFly.svg',       screenshot: A + 'fly-tap-pay.png' },
      { name: 'IG Quick Pay',path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',  screenshot: A + 'app-qr-quickpay.png' },
    ],
  },
};

// ---------------------------------------------------------------------------
// Hotel sub-area configs
// ---------------------------------------------------------------------------
export const hotelAreas = {
  lobby: {
    pageClass: 'lobbyPage',
    mapBg: MAP + 'Hotel-Lobby.png',
    title: 'Lobby',
    text: "Meet your guests where they are... in your lobby, on the casino floor, at the front desk, somewhere on-site at a check-in/out kiosk, or anywhere on their own mobile device. Put your guests in control with preference-based stay options through unified booking, a single itinerary view and your branded mobile guest app.",
    solutions: [
      { name: 'PMS',            path: 'pms',            icon: A + 'AgilysysPMS.svg',           screenshot: A + 'pc-pms.png' },
      { name: 'Guest App',      path: 'guest-app',      icon: A + 'AgilysysGuest.svg',         screenshot: A + 'app-guest.png' },
      { name: 'Book',           path: 'book',           icon: A + 'AgilysysBook.svg',          screenshot: A + 'app-booking.png' },
      { name: 'Express Mobile', path: 'express-mobile', icon: A + 'AgilysysExpressMobile.svg', screenshot: A + 'app-express.png' },
      { name: 'Express Kiosk',  path: 'express-kiosk',  icon: A + 'AgilysysExpressKiosk.svg', screenshot: A + 'kiosk-express.png' },
    ],
  },
  guest: {
    pageClass: 'guestPage',
    mapBg: MAP + 'Hotel-Guest.png',
    hasBackground: true,
    imgFirst: true,
    title: 'Guest Rooms',
    text: "Whether it's room readiness, a late meal delivered to their room, more bathroom towels or a broken TV, you need the right tools to seamlessly and efficiently meet your guests' in-room requirements.",
    solutions: [
      { name: 'IG OnDemand', path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg', screenshot: A + 'app-ondemand-food.png' },
      { name: 'Service',     path: 'service',      icon: A + 'AgilysysService.svg',    screenshot: A + 'app-service.png' },
    ],
  },
  pool: {
    pageClass: 'poolPage',
    mapBg: MAP + 'Hotel-Pool.png',
    title: 'Poolside Dining',
    text: 'Delight guests with food and beverage at-a-click ordering delivered wherever they are. Enhance the poolside experience with fast, easy, mobile ordering and payment to drive increased order volume, improve check size and grow F&B revenue.',
    solutions: [
      { name: 'IG Fly',      path: 'ig-fly',       icon: A + 'AgilysysIGFly.svg',      screenshot: A + 'fly-tap-pay.png' },
      { name: 'IG OnDemand', path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg', screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Quick Pay',path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg', screenshot: A + 'app-qr-quickpay.png' },
      { name: 'Reserve',     path: 'reserve',      icon: A + 'AgilysysReserve.svg',    screenshot: A + 'app-guest-dining.png' },
      { name: 'Guest App',   path: 'guest-app',    icon: A + 'AgilysysGuest.svg',      screenshot: A + 'app-reserve2.png' },
    ],
  },
  'grab-n-go': {
    pageClass: 'marketPage',
    mapBg: MAP + 'Hotel-Market.png',
    imgFirst: true,
    title: 'Grab N Go Market',
    text: "Meeting customers where they prefer is never more important than in a grab n go market. Customers today want many ways to shop, from traditional check-out, to self-service kiosks, online or walk-out options.",
    solutions: [
      { name: 'InfoGenesis', path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'kiosk-retail.png' },
      { name: 'IG Kiosk',   path: 'ig-kiosk',     icon: A + 'AgilysysIGKiosk.svg',    screenshot: A + 'kiosk-checkout.png' },
    ],
  },
  gifts: {
    pageClass: 'giftsPage',
    mapBg: MAP + 'Hotel-Gift-Shop.png',
    imgFirst: true,
    title: 'Gift Shop',
    text: "Ensure that the perfect shirt or hat is in stock at the right price for every guest. With InfoGenesis POS and Agilysys Eatec procurement and perpetual inventory system, not only will you have the items your guests desire, but they can also seamlessly pay by charging to their hotel room, credit cards, gift cards or cash.",
    solutions: [
      { name: 'InfoGenesis', path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'kiosk-retail.png' },
      { name: 'Eatec',       path: 'eatec',        icon: A + 'AgilysysEatec.svg',       screenshot: A + 'tablet-eatec.png' },
    ],
  },
  office: {
    pageClass: 'officePage',
    mapBg: MAP + 'Hotel-Office.png',
    imgFirst: true,
    title: 'Back Office',
    text: 'Achieving High Return Hospitality demands an effective combination of delivering excellence at every guest interaction and optimizing internal operations.',
    solutions: [
      { name: 'PMS',     path: 'pms',     icon: A + 'AgilysysPMS.svg',     screenshot: A + 'pc-office.png' },
      { name: 'Service', path: 'service', icon: A + 'AgilysysService.svg', screenshot: A + 'app-service.png' },
    ],
  },
  valet: {
    pageClass: 'valetPage',
    mapBg: MAP + 'Hotel-Valet.png',
    hasBackground: true,
    imgFirst: true,
    title: 'Valet',
    text: "Whether it's at check-out or retrieving a guest vehicle for an exciting outing, your guests expect real-time 24-hour service.",
    solutions: [
      { name: 'Service', path: 'service', icon: A + 'AgilysysService.svg', screenshot: A + 'app-service.png' },
    ],
  },
  shipping: {
    pageClass: 'shippingPage',
    mapBg: MAP + 'Hotel-Shipping.png',
    imgFirst: true,
    title: 'Shipping & Receiving',
    text: "Don't let unexpected food costs eat away at your profits. Manage inventory on-hand by freshness, warehouse, location and venue.",
    solutions: [
      { name: 'Eatec', path: 'eatec', icon: A + 'AgilysysEatec.svg', screenshot: A + 'tablet-eatec.png' },
    ],
  },
};

// ---------------------------------------------------------------------------
// Dining sub-area configs
// ---------------------------------------------------------------------------
export const diningAreas = {
  restaurant: {
    pageClass: 'restaurantPage',
    mapBg: MAP + 'Dining-Restaurant.png',
    title: 'Restaurant',
    text: 'Deliver memorable, efficient dining experiences in any venue. With data at their fingertips, servers know guest seating choices, food preferences, allergies, personal celebrations and more.',
    solutions: [
      { name: 'InfoGenesis',   path: 'info-genesis',  icon: A + 'AgilysysInfoGenesis.svg',  screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Fly',        path: 'ig-fly',        icon: A + 'AgilysysIGFly.svg',        screenshot: A + 'fly-tap-pay-tall.png' },
      { name: 'Reserve',       path: 'reserve',       icon: A + 'AgilysysReserve.svg',      screenshot: A + 'app-reservations.png' },
      { name: 'IG OnDemand',   path: 'ig-on-demand',  icon: A + 'AgilysysIGOnDemand.svg',   screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Smart Menu', path: 'ig-smart-menu', icon: A + 'AgilysysIGSmartMenu.svg',  screenshot: A + 'app-order-menu.png' },
      { name: 'IG Quick Pay',  path: 'ig-quick-pay',  icon: A + 'AgilysysIGQuickPay.svg',   screenshot: A + 'app-qr-quickpay.png' },
    ],
  },
  kitchen: {
    pageClass: 'kitchenPage',
    mapBg: MAP + 'Dining-Kitchen.png',
    imgFirst: true,
    title: 'Kitchen',
    text: 'Whether diners place their orders via the POS, a self-service kiosk, their desktop or mobile phones, all orders are routed to the kitchen and managed using the IG Kitchen Display System.',
    solutions: [
      { name: 'Eatec',  path: 'eatec',  icon: A + 'AgilysysEatec.svg',  screenshot: A + 'tablet-eatec-2.png' },
      { name: 'IG KDS', path: 'ig-kds', icon: A + 'AgilysysIGKDS.svg',  screenshot: A + 'tablet-kitchen-system.png' },
    ],
  },
  casual: {
    pageClass: 'casualPage',
    mapBg: MAP + 'Dining-Casual.png',
    title: 'Casual Dining',
    text: 'In casual dining environments speed matters most. IG Digital Menu Boards offer simple, highly visible views of menus and promotions, while Agilysys InfoGenesis POS and IG Kiosk provide diners with convenient self-service ordering and quick payment options. The result is fast, accurate and on-time food delivery to keep service moving.',
    solutions: [
      { name: 'InfoGenesis',           path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg',   screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Kiosk',              path: 'ig-kiosk',     icon: A + 'AgilysysIGKiosk.svg',       screenshot: A + 'kiosk-food-order.png' },
      { name: 'IG OnDemand',           path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg',    screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Quick Pay',          path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',    screenshot: A + 'app-qr-quickpay.png' },
      { name: 'IG Digital Menu Board', path: 'digital-menu', icon: A + 'AgilysysIGDigitalMenu.svg', screenshot: A + 'digital-menu.png' },
    ],
  },
  buffet: {
    pageClass: 'buffetPage',
    mapBg: MAP + 'Dining-Buffet.png',
    title: 'Buffet',
    text: "Maximize your patrons' time on the casino floor, not waiting in the buffet line. With Agilysys IG Kiosk for Buffet, they can easily reserve a buffet time for their party on a self-service kiosk, leaving more time to gamble and less time in line.",
    solutions: [
      { name: 'InfoGenesis',           path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg',   screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Kiosk',              path: 'ig-kiosk',     icon: A + 'AgilysysIGKiosk.svg',       screenshot: A + 'kiosk-food-order.png' },
      { name: 'IG Digital Menu Board', path: 'digital-menu', icon: A + 'AgilysysIGDigitalMenu.svg', screenshot: A + 'digital-menu.png' },
    ],
  },
  'food-court': {
    pageClass: 'foodCourtPage',
    mapBg: MAP + 'Dining-Food-Court.png',
    title: 'Food Court',
    text: "Where choice and speed matter most, Agilysys POS solutions provide diners the options they need. With convenient self-service ordering and quick payment options. The result is fast, accurate and on-time food delivery to keep service moving no matter the choice.",
    solutions: [
      { name: 'InfoGenesis',           path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg',   screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Kiosk',              path: 'ig-kiosk',     icon: A + 'AgilysysIGKiosk.svg',       screenshot: A + 'kiosk-food-order.png' },
      { name: 'IG OnDemand',           path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg',    screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Quick Pay',          path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',    screenshot: A + 'app-qr-quickpay.png' },
      { name: 'IG Digital Menu Board', path: 'digital-menu', icon: A + 'AgilysysIGDigitalMenu.svg', screenshot: A + 'digital-menu.png' },
    ],
  },
  'employee-dining': {
    pageClass: 'employeeDiningPage',
    mapBg: MAP + 'Dining-Employee-Dining.png',
    title: 'Employee Dining',
    text: "In casual dining environments speed matters most. IG Digital Menu Boards offer simple, highly visible views of menus and promotions, while Agilysys InfoGenesis POS and IG Kiosk provide diners with the convenient self-service ordering and quick payment options. The result is fast, accurate and on-time food delivery to keep service moving.",
    solutions: [
      { name: 'InfoGenesis',           path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg',   screenshot: A + 'tablet-info-genesis.png' },
      { name: 'IG Kiosk',              path: 'ig-kiosk',     icon: A + 'AgilysysIGKiosk.svg',       screenshot: A + 'kiosk-food-order.png' },
      { name: 'IG Digital Menu Board', path: 'digital-menu', icon: A + 'AgilysysIGDigitalMenu.svg', screenshot: A + 'digital-menu.png' },
    ],
  },
  'food-trucks': {
    pageClass: 'foodTrucksPage',
    mapBg: MAP + 'Dining-Food-Truck.png',
    title: 'Food Trucks',
    text: "Drive-up, pop-up – whatever and wherever the casual dining experience takes place, guests need self-service ordering and payment solutions to keep things fast and simple. Agilysys IG OnDemand and IG Quick Pay are the perfect solutions to fuel your Food Truck service.",
    solutions: [
      { name: 'IG OnDemand', path: 'ig-on-demand', icon: A + 'AgilysysIGOnDemand.svg',  screenshot: A + 'app-ondemand-food.png' },
      { name: 'IG Quick Pay',path: 'ig-quick-pay', icon: A + 'AgilysysIGQuickPay.svg',  screenshot: A + 'app-qr-quickpay.png' },
    ],
  },
};

// ---------------------------------------------------------------------------
// Golf sub-area configs
// ---------------------------------------------------------------------------
export const golfAreas = {
  cart: {
    pageClass: 'cartPage',
    mapBg: MAP + 'Cart.png',
    imgFirst: true,
    title: 'Beverage Cart',
    text: "Nothing pairs better with a 300-yard drive than an icy cold beverage. With IG Fly, our new all-in-one handheld POS, cart attendants can quickly take and fulfill golfers' orders followed by seamless fast payment.",
    solutions: [
      { name: 'IG Fly', path: 'ig-fly', icon: A + 'AgilysysIGFly.svg', screenshot: A + 'fly-tap-pay.png' },
    ],
  },
  hall: {
    pageClass: 'hallPage',
    mapBg: MAP + 'Hall.png',
    imgFirst: true,
    title: 'Event Hall',
    text: 'Make every meeting, social event, ceremony or fundraiser unforgettable with Agilysys Sales & Catering. With convenient event booking, menu selection and comprehensive logistics management, attendees will be guaranteed a truly memorable experience.',
    solutions: [
      { name: 'Sales & Catering', path: 'sales', icon: A + 'AgilysysSales.svg', screenshot: A + 'laptop-catering.png' },
    ],
  },
  lounge: {
    pageClass: 'loungePage',
    mapBg: MAP + 'Lounge.png',
    title: 'Club & Lounge',
    text: 'Deliver comfortable, efficient club & lounge experiences. With member information at their fingertips, servers know food preferences, allergies, personal celebrations and more. Ensure that transactions apply member account rules, pricing and family benefits.',
    solutions: [
      { name: 'InfoGenesis',      path: 'info-genesis', icon: A + 'AgilysysInfoGenesis.svg', screenshot: A + 'tablet-info-genesis.png' },
      { name: 'Membership',       path: 'memberships',  icon: A + 'AgilysysMembership.svg',  screenshot: A + 'app-membership.png' },
      { name: 'Sales & Catering', path: 'sales',        icon: A + 'AgilysysSales.svg',       screenshot: A + 'laptop-catering.png' },
    ],
  },
  shop: {
    pageClass: 'shopPage',
    mapBg: MAP + 'Shop.png',
    title: 'Pro Shop',
    text: 'Ensure that you always have the perfect sleeve of balls or logoed golf wear for every golfer. With InfoGenesis POS and Agilysys Eatec procurement and inventory system, not only will you have the items your guests desire, but they can also seamlessly pay with credit cards, gift cards or cash.',
    solutions: [
      { name: 'Golf',      path: 'golf',      icon: A + 'AgilysysGolf.svg',   screenshot: A + 'pc-golf-sheet.png' },
      { name: 'Book',      path: 'book',      icon: A + 'AgilysysBook.svg',   screenshot: A + 'app-golf-booking.png' },
      { name: 'Guest App', path: 'guest-app', icon: A + 'AgilysysGuest.svg',  screenshot: A + 'app-golf-courses.png' },
      { name: 'Retail',    path: 'retail',    icon: A + 'AgilysysRetail.svg', screenshot: A + 'pc-golf-retail.png' },
    ],
  },
};

// ---------------------------------------------------------------------------
// Solution detail page data
// ---------------------------------------------------------------------------
const VID = 'https://corpheadlesscmssales.blob.core.windows.net/videos/';

export const solutionDetails = {
  'pms': {
    pageClass: 'PMSFPage',
    icon: A + 'AgilysysPMS.svg',
    description: "Agilysys delivers the industry's most modern, robust and innovative PMS solutions aligned with property preferences to preserve the power to choose. From an individual location to an enterprise chain, get the most modern, comprehensive property management solutions for managing your hospitality business.",
    img1: A + 'PMS1.png',
    img2: null,
    video: VID + 'casinopms1.mp4',
    video2: VID + 'casinopms2.mp4',
  },
  'guest-app': {
    pageClass: 'guestAppFPage',
    icon: A + 'AgilysysGuest.svg',
    description: "Wrap your brand around a downloadable app that provides a frictionless guest experience from booking to check-out. Available in both the Android and iOS app stores, the Agilysys Guest App helps you showcase your property and drive revenue.\n\nThis simple mobile app allows guests to book rooms, golf and spa; check-in; use digital room keys; and check-out all from an app with your brand and property data.",
    img1: A + 'guestApp1.png',
    img2: A + 'guestApp2.png',
    video: VID + 'InteractiveGuestApp2.mp4',
    video2: VID + 'casinoguestapp1.mp4',
  },
  'book': {
    pageClass: 'bookPage',
    icon: A + 'AgilysysBook.svg',
    description: "A commission-free, direct-channel, easy-to-use reservation system that is designed to move guests effortlessly through the booking process for room reservations, spa appointments, golf tee times and more.\n\nThe flexible, configurable solution displays real-time availability and the ability to offer room upgrades and service enhancements. The result is increased revenue at lower booking cost.",
    img1: A + 'book1.png',
    img2: A + 'book2.png',
    video: VID + 'casinobook1.mp4',
    video2: VID + 'casinobook2.mp4',
  },
  'reserve': {
    pageClass: 'reserveFPage',
    icon: A + 'AgilysysReserve.svg',
    description: "Activities\n\nA modern cloud-native activity booking and management solution for hotel and resort properties offering a variety of guest activities beyond spa and golf. From lessons, rentals and more, it offers a flexible, configurable solution that will integrate with PMS and POS solutions for guest preferences as well as become part of a common guest itinerary.\n\nDining\n\nA complete online table reservation, wait-list and venue management system that is designed to display and manage seat availability for a wide range of venues including restaurants, pool cabanas, stadiums and arenas, gaming table seats and more.",
    img1: A + 'Reserve1.png',
    img2: A + 'Reserve2.png',
    video: VID + 'InteractiveReserve.mp4',
  },
  'express-mobile': {
    pageClass: 'expressMobileFPage',
    icon: A + 'AgilysysExpressMobile.svg',
    description: "A complete mobile check-in and check-out guest experience with support for:\n\nWith Express, guests can avoid long front desk lines and enjoy a complete contactless process getting to their rooms and the property's amenities faster. The result is reduced lines at the front desk, greater staff productivity, and reduced operating costs.",
    img1: A + 'expressMobile1.png',
    img2: null,
    video: VID + 'InteractiveExpressMobile.mp4',
  },
  'express-kiosk': {
    pageClass: 'expressKioskFPage',
    icon: A + 'AgilysysExpressKiosk.svg',
    description: "Eliminate front desk queues and help make travel more enjoyable by offering a fast and easy approach to efficient guest service.\n\nUse Express Kiosk to give your guests the self-service options they are looking for. Check-in, obtain card present EMV authorization, offer upgrades and alternative room options before dispensing the guest a key. Deploy the kiosk in high traffic areas such as elevator banks or parking areas and let guests quickly view their hotel folio, check-out and receive an electronic copy instantly.\n\nIncrease revenue, reduce overhead, and provide guests with the experience they are looking for with Express Kiosk.",
    img1: A + 'express1.png',
    img2: null,
    video: VID + 'InteractiveExpressKiosk.mp4',
    video2: VID + 'casinoexpresskiosk1.mp4',
  },
  'info-genesis': {
    pageClass: 'infoGenesisFPage',
    icon: A + 'AgilysysInfoGenesis.svg',
    description: "An award-winning enterprise-class point-of-sale solution that processes transactions in the highest volume, most demanding hospitality industry environments worldwide.\n\nA comprehensive POS system, it combines highly interactive terminal and tablet touchscreen applications supporting Windows, Android and iOS devices. Its robust reporting and analysis features, extensive enterprise-grade menu and item configuration capabilities, and multi-language support, help to drive service flexibility and increased operational efficiency.\n\nThe result is improved F&B operations and increased revenue across venues.",
    img1: A + 'InfoGenesis1.png',
    img2: A + 'Infogenesis2.png',
    video: VID + 'casinoig1.mp4',
    video2: VID + 'casinoig2.mov',
  },
  'ig-fly': {
    pageClass: 'IGFlyFPage',
    icon: A + 'AgilysysIGFly.svg',
    description: "Wherever your guests are, that\u2019s where your servers and your POS need to be. No more running from table to terminal and back. IG Fly empowers your staff to do it all on one device: table-side, pool-side, popup-side, wherever- side. Keep guests happy and servers hustling.\n\nBoost guest spending with sleek handheld devices that facilitate order placement and payment acceptance without ever leaving your guests. Servers are readily available to satisfy guest\u2019s immediate requests while providing faster service.",
    img1: A + 'IGFly1.png',
    img2: null,
    video: VID + 'InteractiveIGFly2.mp4',
  },
  'ig-kiosk': {
    pageClass: 'IGKioskFPage',
    icon: A + 'AgilysysIGKiosk.svg',
    description: "A self-service F&B ordering kiosk that integrates with InfoGenesis POS to serve customers 24-7. Guests casually select menu items, process their credit card payment and print a receipt \u2013 all using a simple interface. No service staff required, reducing the time it takes to serve each guest.\n\nFor those who want to make their own choices, on their own time, IG Kiosk offers the freedom to browse menu options whenever it\u2019s most convenient. Perfect for Grab N Go, cafeterias and fast service restaurants.\n\nThe result is improved service, increased efficiency and reduced operating costs.",
    img1: A + 'IGKiosk1.png',
    img2: A + 'IGKiosk2.png',
    video: VID + 'InteractiveIGKiosk.mp4',
  },
  'ig-on-demand': {
    pageClass: 'IGOnDemandFPage',
    icon: A + 'AgilysysIGOnDemand.svg',
    description: "A complete cloud-native contactless self-service F&B ordering solution that offers an intuitive guest-facing order and pay experience. IG OnDemand allows guests to place and pay for orders using their own device \u2013 phone, tablet, laptop \u2013 for pick-up or delivery orders, as well as for a table-side order and pay experience.\n\nIt supports ordering for multiple guests at a table over the course of a meal using their own devices making the ordering process touchless while freeing up staff to spend more time with guests. The result is dramatically increased revenue opportunities and more chances to enhance service.",
    img1: A + 'IGOnDemand1.png',
    img2: A + 'IGOnDemand2.png',
    video: VID + 'casinoondemand1.mov',
    video2: VID + 'casinoondemand2.mov',
  },
  'ig-quick-pay': {
    pageClass: 'IGQuickPayFPage',
    icon: A + 'AgilysysIGQuickPay.svg',
    description: "A cloud-native touchless payment experience allowing guests to use their own mobile device to scan a QR code on the InfoGenesis check linking to a digital copy of the check where they can review it, add a tip & initiate payment.\n\nThe result is a streamlined, fully contactless payment process that protects the health of guests and staff alike, while helping to speed table turnover.",
    img1: A + 'IGQuickPay.png',
    img2: null,
    video: VID + 'InteractiveIGQuickPay.mp4',
  },
  'ig-smart-menu': {
    pageClass: 'IGSmartMenuFPage',
    icon: A + 'AgilysysIGSmartMenu.svg',
    description: "A cloud-native contactless menu display on a guest\u2019s own mobile device - phone, tablet, or laptop. Guests simply scan a QR code to access a venue menu that is linked directly to the actual items available in the OnDemand system, rather than a PDF or a website link.\n\nThe result is a fully contactless menu display experience that protects the health of guests and staff alike, while helping to reduce menu printing and update costs.",
    img1: A + 'IGSmartMenu1.png',
    img2: null,
    video: null,
  },
  'ig-kds': {
    pageClass: 'IGKDSFPage',
    icon: A + 'AgilysysIGKDS.svg',
    description: "An integrated kitchen display system to manage kitchen orders. The Expo Display shows all orders for the kitchen, allowing an expediter to control the flow of orders and preparation times, while an Order Status Display shows guests the status of their orders which can be shown in an ADA format.\n\nFor IG OnDemand customers, KDS can also be deployed in the cloud with support for multiple KDS stations, routing, scheduled orders, a queue tab and sending an SMS message when orders are bumped. The result is a seamless order flow from order taking to kitchen management and guest notification.",
    img1: A + 'IGKitchen1.png',
    img2: null,
    video: VID + 'InteractiveIGKDS.mp4',
  },
  'digital-menu': {
    pageClass: 'digitalMenuFPage',
    icon: A + 'AgilysysIGDigitalMenu.svg',
    description: "IG Digital Menu Board provides a cloud-native large-format digital display on industry standard technology to present high quality images and menus for a variety of venues.\n\nIt allows users to create and design layouts using pre-defined templates, and schedule menus with auto-update at defined times for a specified menu list. It also supports rotating menus with promo prices for items and combos.",
    img1: A + 'digitalMenu1.png',
    img2: null,
    video: null,
  },
  'eatec': {
    pageClass: 'eatecPage',
    icon: A + 'AgilysysEatec.svg',
    description: "A modern, advanced inventory & procurement solution to help control the quality and consistency of your product purchases and inventory levels to help ensure you have all of the ingredients for food & retail management success.\n\nThe solution helps to maximize every dollar by reducing waste, spoilage, theft and overstock. With robust recipe and nutritional information management, Eatec inventory & procurement management is a single flexible solution for multi-location food and item controls.\n\nThe result is lower food costs, fewer out of stock occurrences and streamlined inventory processes.",
    img1: A + 'eatec1.png',
    img2: A + 'eatec2.png',
    video: VID + 'resorteatec1.mp4',
    video2: VID + 'Eatec2.mp4',
  },
  'spa': {
    pageClass: 'spaFPage',
    icon: A + 'AgilysysSpa.svg',
    description: "A modern cloud-native spa management solution for independent spa operators as well as hotel and resort- based locations. Cloud-native, mobile software delivers an effortless check-in and staff scheduling process, while intuitive drag and drop appointment management helps maximize therapist and treatment room utilization. And if the spa is part of a resort, it can integrate with PMS and POS solutions, making it easy to share data across the enterprise.\n\nAnd our guestsense.ai-enabled solution helps optimize revenue and provides a conversational AI Concierge to fully automate the entire reservation flow in a natural conversation.\n\nThe result is increased revenue through yield management insights and an exclusive spa experience for each and every guest.",
    img1: A + 'Spa1.png',
    img2: null,
    video: VID + 'InteractiveSpa.mp4',
    video2: VID + 'casinospa1.mp4',
  },
  'book4time': {
    pageClass: 'book4timePage',
    icon: A + 'Book4Time.svg',
    description: "Drive Spa revenue while delivering a 5-Star guest experience with a solution built to make life easier and integrate with your existing Agilysys systems. Book appointments, set-up loyalty rewards and manage inventory across multiple locations.",
    img1: A + 'book4time1.png',
    img2: A + 'book4time2.png',
    video: VID + 'Book4time_Feb19_2025.mp4',
  },
  'golf': {
    pageClass: 'golfFPage',
    icon: A + 'AgilysysGolf.svg',
    description: "A modern cloud-native pro shop & course management solution for independent as well as hotel and resort courses.\n\nWhether you\u2019re organizing tournaments, scheduling and tracking tee times, managing the pro shop, directing staff or overseeing player experiences, Agilysys Golf provides reliable golf management efficiency.\n\nSince it integrates seamlessly with PMS solutions, it\u2019s easy to share data across the enterprise; accessing player data including personal preferences, play histories and handicaps.",
    img1: A + 'golf.png',
    img2: null,
    video: VID + 'casinogolf1.mp4',
    video2: VID + 'casinogolf2.mp4',
  },
  'retail': {
    pageClass: 'retailFPage',
    icon: A + 'AgilysysRetail.svg',
    description: "Our basic POS solution to support retail item sales for spas, gift shops or pro-shops that don't need a full enterprise POS system. Easily setup and track inventory, sell items as part of other services, and consolidate it all on the guest folio.",
    img1: A + 'Retail1.png',
    img2: null,
    video: null,
  },
  'service': {
    pageClass: 'serviceFPage',
    icon: A + 'AgilysysService.svg',
    description: "Service on time, every time, without over-stressing staff. Real-time texts between guests and service staff simplifies timing, tracking and satisfying requests. Assign and route service requests to a mobile-equipped team to save time and balance workloads. Minimize training time and protect brand standards through guided task instructions.\n\nThe solution offers an enhanced guest experience through 2-way SMS communications with staff, as well as support for guided hotel room cleaning and inspections, and preventive maintenance.",
    img1: A + 'Service1.png',
    img2: A + 'Service2.png',
    img3: A + 'Service3.png',
    video: VID + 'InteractiveServiceStaff.mp4',
    video2: VID + 'InteractiveServiceGuest2.mp4',
    videoLabel: 'Play Staff Video',
    video2Label: 'Play Guest Video',
  },
  'memberships': {
    pageClass: 'membershipsFPage',
    icon: A + 'AgilysysMembership.svg',
    description: "Control your programs by defining the membership types you need. Whether you manage memberships for individuals, families, groups, corporate accounts or all of these, you define the parameters for each.\n\nThe Membership Portal allows easy online registrations for new members and gives members the ability to check their balances and redeem points via gift cards, eCash, loyalty, etc.",
    img1: A + 'Membership1.png',
    img2: A + 'Membership2.png',
    video: null,
  },
  'sales': {
    pageClass: 'salesFPage',
    icon: A + 'AgilysysSales.svg',
    description: "A cloud-native comprehensive sales & event management system that provides powerful tools for hotels, conference centers and resorts of all sizes. With a complete view of every group and event, as well as guests throughout their entire stay, the system fully exposes the value of each guest and group across meeting and shoulder dates.\n\nThe result is improved event revenue opportunities and streamlined management enabling event planners and sales teams to more efficiently sell, manage and service their clients.",
    img1: A + 'Catering1.png',
    img2: null,
    video: null,
  },
  'loyalty': {
    pageClass: 'loyaltyFPage',
    icon: A + 'AgilysysLoyalty.svg',
    description: "A comprehensive loyalty and promotions management solution to help operators track guest preferences and craft a wide variety of programs and offers. Loyalty & Promotions supports point earning and redemption at every guest interaction and provides a guest portal for self-service account management.\n\nThe result is increased guest wallet-share through repeat visits by leveraging guest preferences for targeted promotions and offers.",
    img1: A + 'Loyalty1.png',
    img2: A + 'Loyalty2.png',
    video: VID + 'InteractiveLoyaltyPromotions.mp4',
  },
  'marketing': {
    pageClass: 'marketingPage',
    icon: A + 'AgilysysDigitalMarketing.svg',
    description: "A flexible hospitality marketing automation solution supporting targeted guest email and SMS marketing communications with event and campaign-based rules.\n\nMarketers can segment guests by type or other criteria and send context-related communications at time of reservation, check-in, check-out or by marketing campaign types. Digital email campaigns allow users an inexpensive way to stay connected to their guest throughout the guest journey.\n\nThe result is increased return visits and improved revenue from offers based upon guest segment and journey stage.",
    img1: A + 'marketing1.png',
    img2: A + 'marketing2.png',
    video: VID + 'casinoadm1.mp4',
    video2: VID + 'casinoadm2.mp4',
  },
};
